import ProductBar from "./ProductBar";

export { default as Tab } from "./Tab";

export default ProductBar;



// WEBPACK FOOTER //
// ./src/components/ProductBar/index.js